import { ActionHistoryTablePage } from "@/features/ActionHistory/ActionHistoryTablePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/action-history")({
  component: RouteComponent,
});

function RouteComponent() {
  return <ActionHistoryTablePage />;
}
